/**
 * Customer Stories module - loaded only when feature is enabled and on customer-stories page.
 * Contains CSS and JS for the Customer Stories feature.
 */
import '../site--brandwatch.com/css/components/customer-stories/header-cards.scss';
import '../site--brandwatch.com/css/components/customer-stories/featured-case-studies.scss';
import '../site--brandwatch.com/css/components/customer-stories/case-studies.scss';
import '../site--brandwatch.com/css/components/customer-stories/cta.scss';

require('../site--brandwatch.com/js/customer-stories/case-studies');
require('../site--brandwatch.com/js/customer-stories/header-cards');
require('../site--brandwatch.com/js/customer-stories/featured-case-studies');
